import { useState, MouseEvent } from 'react';

import { SocialDistance } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  ButtonProps,
  CircularProgress,
  IconButton,
  ClickAwayListener,
  Popper,
  Box,
  styled,
} from '@mui/material';

import { useUserContext } from 'hooks';
const StyledPopper = styled(Popper)(({ theme }) => ({
  border: '1px solid #e1e4e8',
  boxShadow: '0 8px 24px rgba(149, 157, 165, 0.2)',
  borderRadius: 6,
  zIndex: theme.zIndex.modal,
  fontSize: 13,
  color: '#24292e',
  backgroundColor: '#fff',
}));
export const EndMasquaradeButton = (props: ButtonProps) => {
  const [endingMasquarade, setEndingMasquerade] = useState(false);
  const { endMasquerade } = useUserContext();
  const handleEndMasquerade = async () => {
    setEndingMasquerade(true);
    await endMasquerade();
    setEndingMasquerade(false);
    window.location.href = '../';
  };
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    if (anchorEl) {
      anchorEl.focus();
    }
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const id = open ? 'end-masquarade-label' : undefined;

  return (
    <>
      <IconButton
        disableRipple
        aria-describedby={id}
        aria-label='end masquarade'
        onClick={handleClick}
        sx={{ color: 'orange' }}
        {...props}
      >
        {endingMasquarade ? <CircularProgress /> : <SocialDistance />}
      </IconButton>
      <StyledPopper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement='bottom-start'
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div>
            <Box
              sx={{
                padding: '8px 10px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Confirm end acting as employer{' '}
              <LoadingButton
                onClick={handleEndMasquerade}
                loading={endingMasquarade}
                sx={{ ml: 1 }}
                size='small'
                variant='contained'
                color='success'
              >
                Confirm
              </LoadingButton>
            </Box>
          </div>
        </ClickAwayListener>
      </StyledPopper>
    </>
  );
};
